import {_addCsrfToken, _setupHiddenLinks} from "../../app/helpers";
import Splide from "@splidejs/splide";
import Choices from "choices.js";


document.addEventListener( 'DOMContentLoaded', function() {
  const sliderItem = document.querySelector('.js--publication_slider');
  if (sliderItem) {
    var splide = new Splide( sliderItem, {
      perPage: 1,
      gap: 24,
      pagination : true,
      arrows: false,
      // heightRatio:  0.5,
      height: 356,
      breakpoints: {
        768: {
          perPage: 1,
          width: '100%',
          height: 148,
        },
        1280: {
          perPage: 1,
          height: 356,
        },
      },
    } );
    splide.mount();
  }

} );

const publicationItem = document.querySelectorAll('.js--publication__item');
const advantageItem = document.querySelectorAll('.js--advantage__item');

if (publicationItem) {
  publicationItem.forEach((item) => {
    item.style.setProperty('--publication-color', item.getAttribute('data-publication-color'));
  });
}

if (advantageItem) {
  advantageItem.forEach((item) => {
    item.style.setProperty('--advantage-color', item.getAttribute('data-advantage-color'));
  });
}

let loadMoreFlag = false;
function loadComments(block, reload) {
  let blockContainer = block.querySelector('.js--comment_list'),
      url = blockContainer.getAttribute('data-action'),
      order = blockContainer.getAttribute('data-order'),
      post_id = blockContainer.getAttribute('data-post_id'),
      nextPage = blockContainer.getAttribute('data-nextpage');

  blockContainer.classList.add('load');
  loadMoreFlag = true;

  if (reload) {
    blockContainer.innerHTML = '';
    nextPage = 0;
  }

  const params = new URLSearchParams({
    post_id: post_id,
    page: nextPage,
    order: order
  });

  fetch(`${url}?${params.toString()}`)
      .then(response => response.json())
      .then(res => {
        if (res.state === 'success') {
          res.data.forEach(item => {
            blockContainer.insertAdjacentHTML('beforeend', item);
          });
        }
        blockContainer.setAttribute('data-nextpage', res.nextPage);
        window.dispatchEvent(new Event("resize"));
      })
      .catch(error => console.error('Ошибка загрузки комментариев:', error))
      .finally(() => {
        loadMoreFlag = false;
        blockContainer.classList.remove('load');
      });
}

function viewCount() {
  const viewCountElement = document.querySelector('div[data-viewcount]');
  if (viewCountElement) {
    setTimeout(() => {
      const url = viewCountElement.getAttribute('data-viewcount');
      const id = viewCountElement.getAttribute('data-id');

      if (url && id) {

        const formData = new FormData();
        if (id) {
          formData.append('id', id);
        }
        _addCsrfToken(formData);
        fetch(url, {
          method: "POST",
          body: formData,
        })
            .then(response => response.json())
            .catch((error) => {
              console.error('Error:', error);

            });

      }
    }, 5000);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  _setupHiddenLinks();
  viewCount();

 const formAddComment = document.querySelector('.js--add_comment_form');
  // if (formAddComment) {
  //
  //   const replyCommentBtn = document.querySelectorAll('.js--reply_btn');
  //   function addCommentEventListener(formAddComment, insertAfterTrigger, commentId, commentScope) {
  //     formAddComment.addEventListener('submit', function (e) {
  //       e.preventDefault();
  //
  //       const form = e.target;
  //       const formData = new FormData(form);
  //       if (commentId) {
  //         formData.append('parent_id', commentId);
  //       }
  //       if (commentScope) {
  //         formData.append('scope_id', commentScope);
  //       }
  //
  //       fetch(form.action, {
  //         method: form.method,
  //         body: formData,
  //       })
  //           .then(response => response.json())
  //           .then(data => {
  //             let success = data.success ?? false;
  //             const loginForm = document.querySelector('.login__wrap');
  //             if (loginForm) {
  //               loginForm.remove();
  //             }
  //             if (!data.success && data.msg) {
  //               form.querySelector('textarea[name="message"]').classList.add('invalid');
  //               const errorElement =  form.querySelector('#message_error');
  //               errorElement.style.display = "block";
  //               errorElement.innerHTML = data.msg;
  //             }
  //             if (insertAfterTrigger) {
  //               if (data.data) {
  //                 formAddComment.insertAdjacentHTML('afterend', data.data);
  //               }
  //             } else {
  //               if (data.data) {
  //                 formAddComment.parentElement.insertAdjacentHTML('afterend', data.data);
  //               }
  //             }
  //             if (window.initializeForms) {
  //               window.initializeForms();
  //             }
  //           })
  //           .catch((error) => {
  //             console.error('Error:', error);
  //           });
  //     });
  //   }
  //   addCommentEventListener(formAddComment);
  //
  //   replyCommentBtn.forEach( (item) => {
  //     item.addEventListener('click', function () {
  //       const comment = item.closest('.js--comment_item');
  //       const existingForm = comment.nextElementSibling;
  //       const commentId = comment.getAttribute('data-comment-id');
  //       const commentScope = comment.getAttribute('data-scope');
  //
  //
  //       if (existingForm && existingForm.classList.contains('js--cloned_comment_form')) {
  //         existingForm.remove();
  //       } else {
  //         const clonedForm = formAddComment.cloneNode(true);
  //         clonedForm.classList.add('js--cloned_comment_form');
  //         comment.insertAdjacentElement('afterend', clonedForm);
  //         addCommentEventListener(clonedForm, true, commentId, commentScope);
  //       }
  //     });
  //   })
  //
  //
  //
  //
  //
  //
  document.querySelector("#page").addEventListener("click", function(e) {
    var target = e.target;

    if (target.matches(".js--comment_list .js--comment_item .js--reply_btn")) {
      var parent = target.closest('.js--comment_item');

      if (!parent.querySelector('.c-send')) {

        var block = document.querySelector('.c-send').cloneNode(true),
            parent_id = document.createElement('input'),
            scope_id = document.createElement('input');

        parent_id.type = 'hidden';
        parent_id.name = 'parent_id';
        parent_id.value = target.getAttribute('data-parent');

        scope_id.type = 'hidden';
        scope_id.name = 'scope_id';
        scope_id.value = target.getAttribute('data-scope');

        block.querySelector('form').append(parent_id, scope_id);
        parent.appendChild(block);
      }

      var siblings = parent.closest('.js--comment_item').querySelectorAll('.js--comment_item');
      siblings.forEach(function(sibling) {
        if (sibling !== parent) {
          var send = sibling.querySelector('.c-send');
          if (send) send.style.display = 'none';
        }
      });

      var cSend = parent.querySelector('.c-send');
      if (cSend) {
        cSend.style.display = (cSend.style.display === 'none' || cSend.style.display === '') ? 'flex' : 'none';
      }

      // initTextareaAutoResize(); // Uncomment if needed
    }
  });

  document.addEventListener('click', function(event) {
      if (event.target.closest('.js--like_btn')) {
        const item = event.target.closest('.js--like_btn');
        const commentItem = event.target.closest('.js--comment_item');
        const likeCount = commentItem.querySelector('.js--like_count');
        const formData = new FormData();
        const commentId = item.getAttribute('data-id');
        const action = item.getAttribute('data-action');

        if (commentId) {
          formData.append('id', commentId);
        }
        _addCsrfToken(formData);


        fetch(action, {
          method: "POST",
          body: formData,
        })
            .then(response => response.json())
            .then(data => {
              console.log('Success:', data);
              item.setAttribute('disabled', 'disabled');
              likeCount.textContent = parseInt(likeCount.textContent) + 1;
            })
            .catch((error) => {
              console.error('Error:', error);

            });


      }
    });

  document.querySelector("#page").addEventListener("click", function(event) {
    const button = event.target.closest("button.form_button");
    if (button && button.matches("form.js--add_comment_form button.form_button")) {

      const form = event.target.closest("form");
      const url = form.getAttribute("action");

      form.classList.add("load");

      const formData = new FormData(form);

      fetch(url, {
        method: "POST",
        body: formData,
      })
          .then(response => response.json())
          .then(res => {
            if (res.state === "success") {
              const counter = document.querySelector(".publication__comment_header_count span");
              if (counter) {
                const count = parseInt(counter.textContent);
                counter.textContent = count + 1;
              }

              if (res.first === 1) {
                form.closest(".publication__comment").insertAdjacentHTML("afterend", res.data);
                document.querySelector(".js--add_comment_form textarea").value = '';
                loadComments(document.querySelector('div[data-load-comments="1"]'), true);
              } else if (parseInt(res.scope) > 0) {
                var scopeList = document.querySelector("#page .js--comment_list div[data-scope='" + res.scope + "']");
                if (scopeList) {
                  scopeList.insertAdjacentHTML("afterend", res.data);
                } else {
                  document.querySelector("#page .js--comment_list #comment" + res.scope).insertAdjacentHTML("afterend", res.data);
                }
              } else {
                document.querySelector("#page .js--comment_list").insertAdjacentHTML("beforeend", res.data);
              }

              if (res.first !== 1) {
                document.querySelectorAll(".js--add_comment_form_wrap").forEach((obj, index) => {
                  if (index === 0) {
                    document.querySelector(".js--add_comment_form textarea").value = '';
                  } else {
                    obj.remove();
                  }
                });

                const block = document.querySelector("#comment" + res.id);
                window.scrollTo({
                  top: block.getBoundingClientRect().top + window.scrollY - 80,
                  behavior: "smooth"
                });
              }

            } else {
              form.querySelector('textarea[name="message"]').classList.add('invalid');
              const errorElement =  form.querySelector('#message_error');
              errorElement.style.display = "block";
              errorElement.innerHTML = res.message;
              if (res.data && res.data.length) {
                const authElement = document.querySelector(".login__wrap");
                if (authElement) {
                  authElement.remove();
                }
                form.closest(".c-send").insertAdjacentHTML("afterend", res.data);

                if (window.initializeForms) {
                  window.initializeForms();
                  if (window.hasOwnProperty('recaptchaInit') && typeof window.recaptchaInit === 'function') {
                    window.recaptchaInit();
                  }
                  window.PhoneMask.init('.js--phoneInput', '+380');
                  window.togglePasswordsVisibility();
                  const selects = document.querySelectorAll('.js--choices');
                  selects.forEach((select, index) => {
                    window.choicesSelects.push(new Choices(select, {
                      removeItemButton: false,
                      classNames: {
                        containerInner: 'select__choices_inner',
                        containerOuter: 'choices form-control',
                      },
                      allowHTML: true,
                      searchResultLimit: 100,
                      itemSelectText: "",
                      noResultsText: 'Нічого не знайдено',
                      searchFields: ['label'],
                      fuseOptions: {
                        threshold: 0,
                      },
                    }));
                  });
                }
              }
            }
          })
          .catch(error => console.error("Ошибка:", error))
          .finally(() => {
            form.classList.remove("load");
          });
    }
  });

  document.querySelector("#page").addEventListener("click", function(e) {
    var target = e.target;

    if (target.matches(".js--sort_comment a[data-order]")) {
      e.preventDefault();

      var order = target.getAttribute('data-order');
      document.querySelector('.js--comment_list').setAttribute('data-order', order);

      var sortButton = document.querySelector('.publication__comment_header_sort_btn');
      if (sortButton) {
        sortButton.textContent = target.textContent;
      }

      loadComments(block, true);
    }
  });

  const block = document.querySelector('div[data-load-comments="1"]');
  const commentsList = block ? block.querySelector('.js--comment_list') : null;

  if (block && commentsList) {
    loadComments(block);
  }

  window.addEventListener('scroll', function() {
    var block = document.querySelector('div[data-load-comments="1"]');
    if (block) {
      var blockContainer = block.querySelector('.js--comment_list');
      var nextPage = blockContainer.getAttribute('data-nextpage');

      if (!nextPage || nextPage === 'false' || loadMoreFlag) {
        return;
      }

      var offsetTop = block.getBoundingClientRect().top + window.pageYOffset;
      var blockHeight = block.offsetHeight;
      var winHeight = window.innerHeight;
      var docScrolltop = window.pageYOffset;
      var blockEnd = offsetTop + blockHeight;

      if (blockEnd - (docScrolltop + winHeight) <= 100) {
        loadComments(block);
      }
    }
  });

});
